export default "__VITE_ASSET__DyvWTQkJ__"